import { render, staticRenderFns } from "./ComponentesGlobais.vue?vue&type=template&id=68f3870b"
import script from "./ComponentesGlobais.vue?vue&type=script&lang=js"
export * from "./ComponentesGlobais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports